export default "__VITE_ASSET__CthHrzHV__"